<template>
  <div class="trusted-by-section">
    <div class="main-container">
      <h4>Trusted by:</h4>
      <div class="logo-container">
        <div>
          <img class="trusted-by-asset" src="../assets/logos/Vertt.png" alt="">
        </div>
        <div>
          <img class="trusted-by-asset" src="../assets/logos/FaceClub.png" alt="">
        </div>
        <div>
          <img class="trusted-by-asset" src="../assets/logos/Innohub.png" alt="">
        </div>
        <div>
          <img class="trusted-by-asset" src="../assets/logos/USD2EN.png" alt="">
        </div>
        <div>
          <img class="trusted-by-asset" src="../assets/logos/ecrowd-logo.png" alt="">
        </div>
        <div>
          <img class="trusted-by-asset" src="../assets/logos/soccer-mondial.png" alt="">
        </div>
      </div>


    </div>


  </div>
</template>

<script>
export default {
  name: 'TrustedBySection',

}
</script>

<style lang="scss">
@import "TrustedBySection.scss";
</style>
